import { USACurrency } from '@loc/helpers/src/currency/data'
import NP from 'number-precision'

import type { TUseSubLogType } from './subLog'

import { getCurrentPrice } from '@/contexts/PlanContext/helpers/getCurrentPrice'

export function usePlanPriceInfo({
  creditsPlan,
  duration,
}: {
  creditsPlan: TUseSubLogType['productsSub']
  duration: number
}) {
  const productPriceGpt35 = creditsPlan?.productsSub
  const currencyInfo = USACurrency

  const gpt35RenderPrice = getCurrentPrice({
    productPrice: productPriceGpt35,
  })

  const totalPice = gpt35RenderPrice.currencyPrice

  const totalPiceMonth = NP.divide(totalPice, duration)

  const totalPriceText = totalPice.toFixed(2)

  const totalPiceMonthText = totalPiceMonth.toFixed(2)

  return {
    currencyInfo,
    totalPriceText,
    gpt3_5RenderPrice: gpt35RenderPrice,
    totalPiceMonthText,
  }
}

export type TUsePlanPriceInfo = ReturnType<typeof usePlanPriceInfo>
